import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import GrowthChallenges from './components/GrowthChallenges';
import PricingV2 from './components/PricingV2';
import Footer from './components/Footer';
import Mentorship from './pages/Mentorship';
import Chip from './pages/Chip';
import FeaturesPage from './pages/FeaturesPage';
import SectionGlow from './components/ui/SectionGlow';
import SiteMetadata from './components/SEO/SiteMetadata';

// Scroll to top on page change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Component for the homepage
const Home = () => {
  // Handle direct links with hash sections
  useEffect(() => {
    // Check if there's a hash in the URL when the app loads
    if (window.location.hash) {
      // Allow the app to render first
      setTimeout(() => {
        const id = window.location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          // Scroll to element with a slight offset to account for the navbar
          window.scrollTo({
            top: element.offsetTop - 80,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <SiteMetadata 
        page="home"
        title="DetailerOS + GRIT SUITE - All-in-One System for Detailing Businesses"
        description="Expert coaching, actionable advice, and powerful software combined in one solution to help detailing professionals scale their businesses. Transform your detailing business with DetailerOS."
        keywords={["auto detailing business coaching", "detailing business management", "auto detail marketing", "lead generation for detailing", "detailing business software", "auto detailer coaching", "detailing business growth"]}
      />
      <Hero />
      <Features />
      <Testimonials />
      <GrowthChallenges />
      <PricingV2 />
    </>
  );
};

// Route wrapper to conditionally show navbar and footer
const RouteWrapper = () => {
  const location = useLocation();
  const isMentorshipPage = location.pathname === '/mentorship';
  
  return (
    <>
      {!isMentorshipPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mentorship" element={<Mentorship />} />
        <Route path="/chip" element={<Chip />} />
        <Route path="/features" element={<FeaturesPage />} />
      </Routes>
      {!isMentorshipPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="relative">
        <SectionGlow />
        <ScrollToTop />
        <RouteWrapper />
      </div>
    </Router>
  );
}

export default App;